/* eslint-disable max-lines */
import { useContext, useEffect, useState } from "react";
import _ from "lodash";
import AppContext from "../../../AppContext";
import {
  getPriceForColorAndSizeAndGroup,
  getCurrentOrderCustomerPriceGroup,
} from "../../../selectors";

const hasProductsPrices = (context) =>
  context.entities.productsPrices !== null &&
  context.entities.productsPrices !== {};

const hasCustomerPriceGroups = (context) =>
  _.size(_.keys(context.entities.customerPriceGroups));

const CalculatePriceForColorsAndSizes = ({
  prices,
  sizes,
  colors,
  context,
  priceGroup,
  setCurrency,
  setPrices,
  currency,
  initialLoading,
  number,
  season,
}) => {
  useEffect(() => {
    if (initialLoading) return;
    const shouldCalculatePrices =
      !prices && hasProductsPrices(context) && hasCustomerPriceGroups(context);

    if (shouldCalculatePrices) {
      const pricesAfterMapping = {};
      colors.forEach((color) => {
        const color_code = color; //code;

        sizes.forEach((size) => {
          const price = getPriceForColorAndSizeAndGroup({
            context,
            color,
            size,
            priceGroup,
            number,
            season,
          }) || { value: 0 };

          pricesAfterMapping[color_code + size] = price.value || 0;
          if (!currency && price.currency !== undefined) {
            setCurrency(price.currency);
          }
        });
      });
      setPrices(pricesAfterMapping);
    }
    // eslint-disable-next-line
  }, [
    prices,
    sizes,
    colors,
    context,
    priceGroup,
    setCurrency,
    setPrices,
    currency,
    number,
    initialLoading,
    season,
  ]);
};

const UpdateTotalForColorAndSizeForQuantities = ({
  prices,
  data,
  colors,
  total,
  setTotal,
  sizes,
}) => {
  const [previousData, setPreviousData] = useState();

  useEffect(() => {
    if (!prices || prices === {}) return;
    if (!sizes || sizes === {}) return;
    if (!colors || colors === {}) return;
    if (!data || data === {}) return;
    if (previousData === JSON.stringify(data)) return;

    const newTotal = { ...total };
    _.keys(data).forEach((d) => {
      colors.forEach((color) => {
        const color_code = color; //.code;

        if (!data || !data[d]) return;
        if (newTotal[d]) {
          newTotal[d][color_code] = 0;
        } else {
          newTotal[d] = {};
          newTotal[d][color_code] = 0;
        }

        const dataForColor = data[d][color_code];
        if (dataForColor) {
          sizes.forEach((size) => {
            if (_.isNil(_.get(data, `${d}.${color_code}.${size}`))) return;
            const price = Number(prices[color_code + size]);
            const count = dataForColor[size] || 0;
            newTotal[d][color_code] += count * price;
          });
        }
      });
      setPreviousData(JSON.stringify(data));
      setTotal(newTotal);
    });
  }, [previousData, prices, data, colors, total, setTotal, sizes]);
};

export const CalculatePrices = ({ colors, sizes, data, number, season }) => {
  const context = useContext(AppContext);
  const priceGroup = getCurrentOrderCustomerPriceGroup(context);
  const [prices, setPrices] = useState(null);
  const [total, setTotal] = useState({});
  const [currency, setCurrency] = useState();

  CalculatePriceForColorsAndSizes({
    prices,
    sizes,
    context,
    colors,
    priceGroup,
    setPrices,
    currency,
    setCurrency,
    number,
    season,
  });

  UpdateTotalForColorAndSizeForQuantities({
    prices,
    data,
    colors,
    sizes,
    total,
    setTotal,
  });

  return { total, currency };
};

export default CalculatePrices;
